import { render, staticRenderFns } from "./HelpMessage.vue?vue&type=template&id=2ab88f36&"
import script from "./HelpMessage.vue?vue&type=script&lang=js&"
export * from "./HelpMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports